module.exports = __webpack_public_path__ + "media/images/flags/UM-d8460a880d63f5b01eb24ac80c38ac2b.svg";